let zipcodeUrl = 'https://cdn.shopify.com/s/files/1/0011/1729/0614/files/Zipcode_list_-_10202026.csv?v=1792516936'
const DEFAULT_LOCATION_STATE = 'ATL';
const ZIP_LOCATION_STALE_DAYS = 30;
const LAST_VISIT_KEY = 'user_last_visit_at';
const GEOCODE_API_KEY = 'AIzaSyBtmiQczD6oNCBS-VmAPZbBW1G0EuZsrJk';
let skipAutoLocationPrompt = false;
let zipcodeListCache = null;

// Fetch the CSV file from the assets folder
async function fetchZipcodeList() {
    try {
        const response = await fetch(zipcodeUrl);
        const csvText = await response.text();

        // Split the CSV text into rows
        const rows = csvText.split('\n');

        // Extract the headers (assuming the first row contains headers)
        const headers = rows[0].split(',').map(header => header.trim());

        // Parse the rest of the CSV rows into an array of objects
        const data = rows.slice(1).map(row => {
            const values = row.split(',');
            let obj = {};
            headers.forEach((header, index) => {
                obj[header] = values[index].trim();
            });
            return obj;
        });

        zipcodeListCache = data;
        return data;
    } catch (error) {
        console.error('Error fetching or processing the CSV file:', error);
        return [];
    }
}

async function getZipcodeList() {
    if (zipcodeListCache) {
        return zipcodeListCache;
    }
    return fetchZipcodeList() || [];
}

function findFirstLocationByState(zipcodeList, stateAbrev) {
    return zipcodeList.find(item => item.location_abrev === stateAbrev);
}

function updateZipcodeOutputs(zipcode) {
    if (!zipcode || zipcode === 'not found') {
        return;
    }
    document.querySelectorAll('.zipcode-output').forEach(output => {
        output.value = zipcode;
    });
}

function formatServescapePrice(amount) {
    var value = Number(amount);
    if (isNaN(value)) {
        return '$0.00';
    }

    var isNegative = value < 0;
    value = Math.abs(value);
    var parts = value.toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (isNegative ? '-' : '') + '$' + parts.join('.');
}
window.formatServescapePrice = formatServescapePrice;

function variantTracksInventory(variant) {
    return !!(variant && variant.inventory_management === 'shopify');
}
window.variantTracksInventory = variantTracksInventory;

function getServescapeVariantById(variantId) {
    var variantJsonEl = document.querySelector('[data-variant-json]');
    if (!variantJsonEl) {
        return null;
    }
    var variants = JSON.parse(variantJsonEl.textContent);
    return variants.find(function (variant) {
        return variant.id === Number(variantId);
    }) || null;
}
window.getServescapeVariantById = getServescapeVariantById;

function getServescapeVariantId(variant) {
    if (!variant) {
        return null;
    }
    var id = variant.variantId != null ? variant.variantId : variant.id;
    return id != null && !isNaN(Number(id)) ? Number(id) : null;
}

function resolveServescapeVariantPrices(variant) {
    var variantId = getServescapeVariantId(variant);
    var shopifyVariant = variantId ? getServescapeVariantById(variantId) : null;
    if (shopifyVariant) {
        return {
            price: shopifyVariant.price / 100,
            compareAtPrice: shopifyVariant.compare_at_price ? shopifyVariant.compare_at_price / 100 : 0
        };
    }

    var price = Number(variant.variantPrice != null ? variant.variantPrice : variant.price);
    var compareAtPrice = Number(
        variant.variantCompareAtPrice != null ? variant.variantCompareAtPrice : variant.compare_at_price
    );
    return {
        price: isNaN(price) ? 0 : price,
        compareAtPrice: isNaN(compareAtPrice) ? 0 : compareAtPrice
    };
}
window.resolveServescapeVariantPrices = resolveServescapeVariantPrices;

function syncServescapeVariantState(matchingVariant, productContainer) {
    if (!matchingVariant || !productContainer) {
        return;
    }

    var variantId = matchingVariant.id.toString();
    var variantSelect = productContainer.querySelector('[data-product-select]');

    if (variantSelect) {
        variantSelect.value = variantId;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    localStorage.setItem('selected_variant_id', variantId);

    if (history.replaceState) {
        var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + matchingVariant.id;
        window.history.replaceState({ path: newurl }, '', newurl);
    }

    productContainer.dispatchEvent(new CustomEvent('variantChange', {
        detail: { variant: matchingVariant }
    }));
}
window.syncServescapeVariantState = syncServescapeVariantState;

function updateWindowInventories(productId, data) {
    if (!data || !Array.isArray(data)) {
        return;
    }
    var locationId = localStorage.getItem('current_location_id');
    if (locationId === 'not found' || locationId === null) {
        return;
    }
    window.inventories = window.inventories || {};
    window.inventories[productId] = {};
    for (var i = 0; i < data.length; i++) {
        var item = data[i];
        var inv = item.inventory;
        window.inventories[productId][item.variantId] = {
            quantity: Array.isArray(inv) && inv.length > 0 && inv[0].available,
            location_id: locationId,
            price: item.variantPrice,
            compare_at_price: item.variantCompareAtPrice,
            weight: item.variantWeight,
        };
    }
}

function findInventoryItemByVariantId(data, variantId) {
    if (!data || variantId == null || variantId === 'none' || variantId === 'undefined') {
        return null;
    }
    return data.find(function (item) {
        return item.variantId === Number(variantId);
    }) || null;
}

function getSelectedProductOptionMap(productContainer) {
    productContainer = productContainer || document.querySelector('.ss--product-template__container');
    var selectedOptions = {};
    if (!productContainer) {
        return selectedOptions;
    }

    productContainer.querySelectorAll('[data-variant-input]').forEach(function (input) {
        if (input.type === 'radio' && input.checked) {
            selectedOptions[input.dataset.index] = input.value;
        } else if (input.type !== 'radio' && input.value) {
            selectedOptions[input.dataset.index] = input.value;
        }
    });

    return selectedOptions;
}
window.getSelectedProductOptionMap = getSelectedProductOptionMap;

function getVariantOptionMatchCount(variant, selectedOptions) {
    return Object.keys(selectedOptions).filter(function (optionIndex) {
        return variant[optionIndex] === selectedOptions[optionIndex];
    }).length;
}

function findBestVariantMatch(variants, selectedOptions, preferredOptionIndex, preferredValue) {
    if (!variants || !variants.length) {
        return null;
    }

    var optionKeys = Object.keys(selectedOptions || {});
    if (optionKeys.length) {
        var exactMatch = variants.find(function (variant) {
            return optionKeys.every(function (optionIndex) {
                return variant[optionIndex] === selectedOptions[optionIndex];
            });
        });
        if (exactMatch) {
            return exactMatch;
        }

        var candidates = variants;
        if (preferredOptionIndex && preferredValue) {
            var preferredMatches = variants.filter(function (variant) {
                return variant[preferredOptionIndex] === preferredValue;
            });
            if (preferredMatches.length) {
                candidates = preferredMatches;
            }
        }

        candidates = candidates.slice().sort(function (a, b) {
            return getVariantOptionMatchCount(b, selectedOptions) - getVariantOptionMatchCount(a, selectedOptions);
        });
        if (candidates.length) {
            return candidates[0];
        }
    }

    return variants[0] || null;
}

function syncOptionInputsToVariant(variant, productContainer) {
    if (!variant || !productContainer) {
        return;
    }

    productContainer.querySelectorAll('[data-variant-input]').forEach(function (input) {
        var optionIndex = input.dataset.index;
        if (!optionIndex || variant[optionIndex] == null) {
            return;
        }
        if (input.type === 'radio' || input.type === 'checkbox') {
            input.checked = variant[optionIndex] === input.value;
        } else {
            input.value = variant[optionIndex];
        }
    });
}

function getCurrentlySelectedShopifyVariant(productContainer, preferredOptionIndex, preferredValue) {
    productContainer = productContainer || document.querySelector('.ss--product-template__container');
    var variantJsonEl = document.querySelector('[data-variant-json]');
    if (!variantJsonEl) {
        return null;
    }

    var variants;
    try {
        variants = JSON.parse(variantJsonEl.textContent);
    } catch (e) {
        return null;
    }
    if (!Array.isArray(variants) || !variants.length) {
        return null;
    }

    var selectedOptions = getSelectedProductOptionMap(productContainer);
    var matchingVariant = findBestVariantMatch(variants, selectedOptions, preferredOptionIndex, preferredValue);
    if (matchingVariant) {
        return matchingVariant;
    }

    var selectedVariantId = localStorage.getItem('selected_variant_id');
    if (selectedVariantId && selectedVariantId !== 'none' && selectedVariantId !== 'undefined') {
        var fromStorage = variants.find(function (variant) {
            return variant.id === Number(selectedVariantId);
        });
        if (fromStorage) {
            return fromStorage;
        }
    }

    var currentVariantEl = document.querySelector('[data-current-variant-json]');
    if (currentVariantEl) {
        try {
            var currentVariant = JSON.parse(currentVariantEl.textContent);
            var fromCurrent = variants.find(function (variant) {
                return variant.id === Number(currentVariant.id);
            });
            if (fromCurrent) {
                return fromCurrent;
            }
        } catch (e) { }
    }

    return variants[0] || null;
}

window.getCurrentlySelectedShopifyVariant = getCurrentlySelectedShopifyVariant;

function getSelectedVariantFromData(data, productContainer) {
    if (!data || !data.length) {
        return null;
    }

    var matchingVariant = getCurrentlySelectedShopifyVariant(productContainer);
    if (matchingVariant) {
        var fromSelected = findInventoryItemByVariantId(data, matchingVariant.id);
        if (fromSelected) {
            return fromSelected;
        }
        return {
            variantId: matchingVariant.id,
            inventory: [{ available: 0 }],
            variantPrice: matchingVariant.price / 100,
            variantCompareAtPrice: matchingVariant.compare_at_price ? matchingVariant.compare_at_price / 100 : 0,
            variantWeight: matchingVariant.weight
        };
    }

    var selectedVariantId = localStorage.getItem('selected_variant_id');
    var fromStorage = findInventoryItemByVariantId(data, selectedVariantId);
    if (fromStorage) {
        return fromStorage;
    }

    return data[0];
}
window.getSelectedVariantFromData = getSelectedVariantFromData;

function applyVariantAvailabilityUI(matchingVariant) {
    var productContainer = document.querySelector('.ss--product-template__container');
    var inventoryText = document.querySelector('.ss--inventory-amount');
    var inventoryIcon = document.querySelector('.ss--inventory-icon-text .icon');
    var ctaButton = document.querySelector('.ss--cta-button.add-to-cart');
    var inputQuantity = document.querySelector('.product__quantity .ss--quantity-input__wrapper input');

    function hideAddToCart(isOutOfStock) {
        if (inputQuantity) {
            inputQuantity.setAttribute('max', 0);
        }
        if (isOutOfStock && inventoryText) {
            inventoryText.innerText = 'Out of stock';
            inventoryText.style = 'color: red';
        }
        if (isOutOfStock && inventoryIcon) {
            inventoryIcon.style = 'visibility: hidden; width: 0px; margin: 0';
        }
        if (ctaButton) {
            ctaButton.style.display = 'none';
        }
    }

    if (!matchingVariant || !productContainer) {
        hideAddToCart(true);
        return;
    }

    var productId = productContainer.getAttribute('data-product-id');
    var variantId = (matchingVariant.id != null ? matchingVariant.id : matchingVariant.variantId);
    if (variantId == null) {
        hideAddToCart(true);
        return;
    }
    variantId = variantId.toString();

    var shopifyVariant = matchingVariant.inventory_management != null
        ? matchingVariant
        : getServescapeVariantById(variantId);
    var tracksInventory = variantTracksInventory(shopifyVariant || matchingVariant);
    var inventoryRecord = window.inventories && window.inventories[productId]
        ? window.inventories[productId][variantId]
        : null;

    if (tracksInventory && !inventoryRecord) {
        hideAddToCart(true);
        return;
    }

    var variantQuantity = inventoryRecord ? (inventoryRecord.quantity || 0) : 0;
    var isAvailable = tracksInventory
        ? Number(variantQuantity) > 0
        : !shopifyVariant || shopifyVariant.available !== false;

    if (isAvailable) {
        if (tracksInventory) {
            if (inputQuantity) {
                inputQuantity.setAttribute('max', variantQuantity);
            }
            if (inventoryText) {
                inventoryText.innerText = variantQuantity + ' available';
                inventoryText.style = 'color: #2E5035;';
            }
            if (inventoryIcon) {
                inventoryIcon.style = 'visibility: visible';
            }
        }
        if (ctaButton) {
            ctaButton.style.display = 'inline-block';
            ctaButton.disabled = false;
        }
    } else {
        hideAddToCart(true);
    }
}
window.applyVariantAvailabilityUI = applyVariantAvailabilityUI;

async function productDisplayPriceHandle() {
    var productContainer = document.querySelector('.ss--product-template__container');
    var priceBlock = productContainer && productContainer.querySelector('.product-block--price');
    if (!productContainer || !priceBlock) {
        return;
    }

    var productId = productContainer.getAttribute('data-product-id');
    var locationId = localStorage.getItem('current_location_id');
    var url = window.SS_INSTASCAPE_URL + '/api/inventory/' + productId + '/' + locationId;
    var priceApplied = false;

    try {
        var response = await fetch(url);
        if (response.ok) {
            var contentType = response.headers.get('content-type');
            if (contentType && contentType.includes('application/json')) {
                var data = await response.json();
                if (Array.isArray(data) && data.length) {
                    updateWindowInventories(productId, data);

                    if (document.querySelector('.ss--variant-wrapper') && typeof variantButtonsHandler === 'function') {
                        variantButtonsHandler();
                    }

                    var selectedVariant = getSelectedVariantFromData(data, productContainer);
                    if (selectedVariant) {
                        ssProductPriceHandle(selectedVariant);
                        priceApplied = true;
                    }
                }
            }
        }
    } catch (error) {
        console.error('Error fetching product price:', error);
    }

    // Gift cards / non-inventory products: fall back to Shopify variant JSON.
    if (!priceApplied) {
        applyProductPriceFromShopifyVariants(productContainer);
    }
}

function applyProductPriceFromShopifyVariants(productContainer) {
    productContainer = productContainer || document.querySelector('.ss--product-template__container');
    if (!productContainer) {
        return;
    }

    var variantJsonEl = document.querySelector('[data-variant-json]');
    if (!variantJsonEl) {
        return;
    }

    var variants;
    try {
        variants = JSON.parse(variantJsonEl.textContent);
    } catch (e) {
        return;
    }
    if (!Array.isArray(variants) || !variants.length) {
        return;
    }

    var selectedOptions = {};
    productContainer.querySelectorAll('[data-variant-input]').forEach(function (input) {
        if (input.type === 'radio' && input.checked) {
            selectedOptions[input.dataset.index] = input.value;
        } else if (input.type !== 'radio' && input.value) {
            selectedOptions[input.dataset.index] = input.value;
        }
    });

    var matchingVariant = null;
    if (Object.keys(selectedOptions).length) {
        matchingVariant = variants.find(function (variant) {
            return Object.keys(selectedOptions).every(function (optionIndex) {
                return variant[optionIndex] === selectedOptions[optionIndex];
            });
        });
    }

    if (!matchingVariant) {
        var selectedVariantId = localStorage.getItem('selected_variant_id');
        if (selectedVariantId && selectedVariantId !== 'none') {
            matchingVariant = variants.find(function (variant) {
                return variant.id === Number(selectedVariantId);
            });
        }
    }

    if (!matchingVariant) {
        matchingVariant = variants.find(function (variant) {
            return variant.available !== false;
        }) || variants[0];
    }

    if (matchingVariant) {
        ssProductPriceHandle(matchingVariant);
    }
}

function ssProductPriceHandle(variant) {
    if (!variant) {
        return;
    }
    var productContainer = document.querySelector('.ss--product-template__container');
    if (!productContainer) {
        return;
    }
    var priceBlocks = productContainer.querySelectorAll('.product-block--price');
    if (!priceBlocks.length) {
        return;
    }

    var productType = priceBlocks[0].getAttribute('data-product-type');
    var productTitle = priceBlocks[0].getAttribute('data-product-title')
        || productContainer.getAttribute('data-product-title')
        || '';
    var servescape_pro = window.localStorage.getItem('servescape_pro') === 'true';
    var displayDiscountPercent = typeof window.getServescapeProductDisplayDiscountPercent === 'function'
        ? window.getServescapeProductDisplayDiscountPercent(productType, productTitle)
        : 0;
    var resolvedPrices = resolveServescapeVariantPrices(variant);
    var price = resolvedPrices.price;
    var compareAtPrice = resolvedPrices.compareAtPrice;
    var finalAmount = price;
    var showPromoDiscount = false;

    var showProLabel = servescape_pro
        && typeof window.isServescapeDiscountExcluded === 'function'
        && !window.isServescapeDiscountExcluded(productType, null, productTitle);

    if (displayDiscountPercent > 0 && !servescape_pro) {
        finalAmount = price * (1 - displayDiscountPercent / 100);
        showPromoDiscount = true;
    } else if (showProLabel) {
        finalAmount = price * 0.70;
        showPromoDiscount = true;
    }

    var showCompareAt = !showPromoDiscount && compareAtPrice > price;
    var finalPriceText = formatServescapePrice(finalAmount);

    priceBlocks.forEach(function (priceBlock) {
        var spanFinalPrice = priceBlock.querySelector('.ss--product__final-price');
        var spanOriginalPrice = priceBlock.querySelector('.ss--product__orginal-price');
        var spanCompareAtPrice = priceBlock.querySelector('.ss--product__compare-at-price');
        var spanSaleLabel = priceBlock.querySelector('.ss--product__sale-label');
        var spanProLabel = priceBlock.querySelector('.ss--product__pro-label');

        if (!spanFinalPrice) {
            return;
        }

        if (spanOriginalPrice) {
            spanOriginalPrice.classList.toggle('hide', !showPromoDiscount);
            spanOriginalPrice.innerText = showPromoDiscount ? formatServescapePrice(price) : '';
        }
        if (spanCompareAtPrice) {
            spanCompareAtPrice.innerText = showCompareAt ? formatServescapePrice(compareAtPrice) : '';
        }
        if (spanSaleLabel) {
            spanSaleLabel.classList.toggle('hide', !(showPromoDiscount || showCompareAt));
        }
        if (spanProLabel) {
            spanProLabel.classList.toggle('hide', !showProLabel);
        }
        spanFinalPrice.innerText = finalPriceText;
    });
}


function updateVariantOptionLabels(productContainer) {
    productContainer = productContainer || document.querySelector('.ss--product-template__container');
    if (!productContainer) {
        return;
    }

    var selectedOptions = getSelectedProductOptionMap(productContainer);
    productContainer.querySelectorAll('[data-variant-option-label]').forEach(function (label) {
        var optionKey = label.getAttribute('data-option-key');
        if (optionKey && selectedOptions[optionKey]) {
            label.textContent = selectedOptions[optionKey];
        }

        var wrapper = label.closest('.ss--variant-wrapper');
        var selectedInput = wrapper ? wrapper.querySelector('[data-variant-input]:checked') : null;
        var isUnavailable = !!(selectedInput && selectedInput.classList.contains('disabled'));
        label.classList.toggle('is-unavailable', isUnavailable);
    });
}
window.updateVariantOptionLabels = updateVariantOptionLabels;

function ssVariantClickHandle(variantButton) {
    const productContainer = document.querySelector('.ss--product-template__container')
    if (!productContainer) return

    const clickedInput = variantButton.querySelector('input[type="radio"]')
    if (clickedInput) {
        var wasChecked = clickedInput.checked
        clickedInput.checked = true
        if (!wasChecked) {
            clickedInput.dispatchEvent(new Event('change', { bubbles: true }))
        }
    }

    const matchingVariant = getCurrentlySelectedShopifyVariant(
        productContainer,
        clickedInput && clickedInput.dataset.index,
        clickedInput && clickedInput.value
    )

    if (!matchingVariant) {
        return
    }

    syncOptionInputsToVariant(matchingVariant, productContainer)
    syncServescapeVariantState(matchingVariant, productContainer)

    // Update price from Shopify catalog; inventory API is used for stock only.
    ssProductPriceHandle(matchingVariant)
    applyVariantAvailabilityUI(matchingVariant)
    if (typeof variantButtonsHandler === 'function') {
        variantButtonsHandler()
    }
    updateVariantOptionLabels(productContainer)
}

document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) {
        return;
    }
    applyVariantAvailabilityUI(variant);
    if (typeof variantButtonsHandler === 'function') {
        variantButtonsHandler();
    }
    updateVariantOptionLabels();
});

function zipModalPopupHandler() {
    const zipModal = document.querySelector(' .ss--zipcode-modal-popup');
    zipModal.classList.add('showup');
}

function zipModalCloseHandler() {
    const zipModal = document.querySelector('.ss--zipcode-modal-popup');
    zipModal.classList.remove('showup')
}


function getZipPopupElements() {
    const modal = document.querySelector('.ss--zipcode-modal-popup');
    if (!modal) {
        return null;
    }
    return {
        input: modal.querySelector('input#zip'),
        zipMessage: modal.querySelector('.zip-message'),
        spinner: modal.querySelector('.spinner-save-zip'),
        textBtn: modal.querySelector('.save-zip-text'),
        saveBtn: modal.querySelector('.save-zip-btn'),
    };
}

function resetSaveZipButton(elements) {
    if (!elements) {
        return;
    }
    if (elements.spinner) {
        elements.spinner.style.visibility = 'hidden';
    }
    if (elements.textBtn) {
        elements.textBtn.style.visibility = 'visible';
    }
    if (elements.saveBtn) {
        elements.saveBtn.disabled = false;
    }
}

function validateInput() {
    const elements = getZipPopupElements();
    const input = elements && elements.input ? elements.input : document.querySelector('input#zip');
    if (!input) {
        return;
    }

    input.value = input.value.replace(/\D/g, '').slice(0, 5);

    if (elements && elements.zipMessage) {
        elements.zipMessage.textContent = '';
    }
}

function postalCodeFromGeocodeResult(result) {
    const components = (result && result.address_components) || [];
    const postal = components.find(function (component) {
        return component.types && component.types.indexOf('postal_code') !== -1;
    });
    if (!postal || !postal.long_name) {
        return '';
    }
    return String(postal.long_name).replace(/\D/g, '').slice(0, 5);
}

function setCurrentLocationButtonBusy(isBusy) {
    const buttonText = document.querySelector('.current-zip-btn .button-text');
    const spinner = document.querySelector('.current-zip-btn .spinner');
    const currentButton = document.querySelector('.current-zip-btn');
    if (spinner) {
        spinner.style.visibility = isBusy ? 'visible' : 'hidden';
    }
    if (buttonText) {
        buttonText.style.visibility = isBusy ? 'hidden' : 'visible';
    }
    if (currentButton) {
        currentButton.disabled = isBusy;
    }
}

function showZipPopupMessage(message) {
    zipModalPopupHandler();
    const popup = getZipPopupElements();
    if (popup && popup.zipMessage) {
        popup.zipMessage.textContent = message;
        popup.zipMessage.style.color = 'red';
    }
}

function googleCurrentLocationHandle() {
    if (!navigator.geolocation) {
        showZipPopupMessage('Location is not available in this browser. Enter your zip code instead.');
        return;
    }

    setCurrentLocationButtonBusy(true);

    navigator.geolocation.getCurrentPosition(
        function (position) {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            fetch('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&key=' + GEOCODE_API_KEY)
                .then(function (response) { return response.json(); })
                .then(function (data) {
                    const zipcode = data.status === 'OK' && data.results && data.results.length
                        ? postalCodeFromGeocodeResult(data.results[0])
                        : '';
                    if (zipcode.length !== 5) {
                        setCurrentLocationButtonBusy(false);
                        showZipPopupMessage('We could not read a zip code from your location. Enter it instead.');
                        return;
                    }
                    return findZipcodeAndUpdateLocalStorage(zipcode).then(function (result) {
                        if (!result.found) {
                            setCurrentLocationButtonBusy(false);
                            showZipPopupMessage('Sorry, this zip code is not served in our delivery area.');
                        }
                    });
                })
                .catch(function () {
                    setCurrentLocationButtonBusy(false);
                    showZipPopupMessage('We could not look up your location. Enter your zip code instead.');
                });
        },
        function () {
            setCurrentLocationButtonBusy(false);
            showZipPopupMessage('Location access was blocked. Enter your zip code instead.');
        },
        { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
    );
}

function visitNeedsLocationPrompt() {
    const previousVisit = Number(localStorage.getItem(LAST_VISIT_KEY) || 0);
    const now = Date.now();
    localStorage.setItem(LAST_VISIT_KEY, String(now));
    if (!previousVisit) {
        return true;
    }
    const staleMs = ZIP_LOCATION_STALE_DAYS * 24 * 60 * 60 * 1000;
    return (now - previousVisit) > staleMs;
}

async function maybeRequestZipFromLocation() {
    const needsPrompt = visitNeedsLocationPrompt();
    if (skipAutoLocationPrompt || !needsPrompt) {
        return;
    }
    if (!navigator.geolocation) {
        return;
    }

    let permission = 'prompt';
    try {
        if (navigator.permissions && navigator.permissions.query) {
            const status = await navigator.permissions.query({ name: 'geolocation' });
            permission = status.state;
        }
    } catch (error) {
        permission = 'prompt';
    }

    if (permission === 'denied') {
        return;
    }
    if (permission === 'granted') {
        googleCurrentLocationHandle();
        return;
    }

    zipModalPopupHandler();
}

async function saveCustomLocationHandle() {
    const elements = getZipPopupElements();
    if (!elements || !elements.input) {
        return;
    }

    const { input, zipMessage, spinner, textBtn, saveBtn } = elements;

    if (input.value.length === 5 && !isNaN(parseInt(input.value, 10))) {
        textBtn.style.visibility = 'hidden';
        spinner.style.visibility = 'visible';
        zipMessage.textContent = '';
        if (saveBtn) {
            saveBtn.disabled = true;
        }

        const result = await findZipcodeAndUpdateLocalStorage(input.value);

        if (!result.found) {
            zipMessage.textContent = 'Sorry, this zip code is not served in our delivery area.';
            zipMessage.style.color = 'red';
            resetSaveZipButton(elements);
        }
    } else {
        zipMessage.textContent = 'Invalid ZIP Code! Please enter a valid 5-digit ZIP code.';
        zipMessage.style.color = 'red';
    }
}

const LOCATION_URL_PARAM = 'location';

function getLocationAbrevFromUrl() {
    const locationAbrev = new URLSearchParams(window.location.search).get(LOCATION_URL_PARAM);
    return locationAbrev ? locationAbrev.toUpperCase() : null;
}

function removeLocationParamFromUrl() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(LOCATION_URL_PARAM)) {
        return;
    }
    url.searchParams.delete(LOCATION_URL_PARAM);
    window.history.replaceState({}, '', url.toString());
}

function stateExistsInList(zipcodeList, stateAbrev) {
    return zipcodeList.some(item => item.location_abrev === stateAbrev);
}

function getPersistedLocationState() {
    const persisted = localStorage.getItem('user_location_state');
    return persisted ? persisted.toUpperCase() : null;
}

function setPersistedLocationState(stateAbrev) {
    if (stateAbrev) {
        localStorage.setItem('user_location_state', stateAbrev);
    }
}

function getCurrentLocationState() {
    return getPersistedLocationState();
}

/**
 * One-time ?location= handler: valid → that location; invalid → ATL. Always strips param from URL.
 */
function consumeLocationFromUrl(zipcodeList) {
    const urlLocation = getLocationAbrevFromUrl();
    if (!urlLocation) {
        return null;
    }

    skipAutoLocationPrompt = true;
    removeLocationParamFromUrl();

    if (stateExistsInList(zipcodeList, urlLocation)) {
        return urlLocation;
    }
    return DEFAULT_LOCATION_STATE;
}

/** Persisted state → zip-derived state → ATL (first visit). */
function resolveStateAbrevFromStorage(zipcodeList) {
    const persistedState = getPersistedLocationState();
    if (persistedState && persistedState !== 'NOT FOUND') {
        return persistedState;
    }

    const savedZip = localStorage.getItem('user_zipcode');
    if (savedZip && savedZip !== 'not found') {
        const savedRow = zipcodeList.find(item => item.zipcode === savedZip);
        if (savedRow && savedRow.location_abrev) {
            return savedRow.location_abrev;
        }
    }

    return DEFAULT_LOCATION_STATE;
}

function applyLocationForState(zipcodeList, stateAbrev, options) {
    const forceFirstZip = options && options.forceFirstZip;
    const firstForState = findFirstLocationByState(zipcodeList, stateAbrev);
    const savedZip = localStorage.getItem('user_zipcode');
    const savedRow = savedZip ? zipcodeList.find(item => item.zipcode === savedZip) : null;
    const zipBelongsToState = savedRow && savedRow.location_abrev === stateAbrev;

    if (firstForState) {
        localStorage.setItem('current_location_id', firstForState.location_id);
        if (forceFirstZip || !savedZip || savedZip === 'not found' || !zipBelongsToState) {
            localStorage.setItem('user_zipcode', firstForState.zipcode);
        }
    } else {
        localStorage.setItem('current_location_id', 'not found');
        if (forceFirstZip || !savedZip || savedZip === 'not found') {
            localStorage.setItem('user_zipcode', 'not found');
        }
    }

    localStorage.removeItem('current_location_abrev');

    const resolvedState = firstForState ? firstForState.location_abrev : 'not found';
    setPersistedLocationState(resolvedState);
    updateZipcodeOutputs(localStorage.getItem('user_zipcode'));

    return {
        stateAbrev: resolvedState,
        locationId: localStorage.getItem('current_location_id'),
        zipcode: localStorage.getItem('user_zipcode'),
    };
}

/**
 * Resolve location from localStorage. Optional ?location= is consumed once then removed from URL.
 */
async function initLocationFromUrlOrDefault() {
    const zipcodeList = await getZipcodeList();
    const locationFromUrl = consumeLocationFromUrl(zipcodeList);

    if (locationFromUrl !== null) {
        return applyLocationForState(zipcodeList, locationFromUrl, { forceFirstZip: true });
    }

    const stateAbrev = resolveStateAbrevFromStorage(zipcodeList);
    return applyLocationForState(zipcodeList, stateAbrev, { forceFirstZip: false });
}

function reloadPagePreservingParams() {
    const url = new URL(window.location.href);
    url.searchParams.delete(LOCATION_URL_PARAM);
    localStorage.setItem('selected_variant_id', 'none');
    window.location.href = url.toString();
}

async function findZipcodeAndUpdateLocalStorage(zipcode) {
    const zipcodeList = await getZipcodeList();
    const currentLocation = zipcodeList.find(item => item.zipcode === zipcode);

    if (!currentLocation) {
        return { found: false };
    }

    localStorage.setItem('user_zipcode', zipcode);
    localStorage.setItem('current_location_id', currentLocation.location_id);
    setPersistedLocationState(currentLocation.location_abrev);
    localStorage.removeItem('current_location_abrev');
    reloadPagePreservingParams();
    return { found: true };
}

window.initLocationFromUrlOrDefault = initLocationFromUrlOrDefault;
window.getCurrentLocationState = getCurrentLocationState;
window.syncStateUrlFromZipcode = initLocationFromUrlOrDefault;

// Function to get the current search parameters as an object with numeric conversion
function getCurrentSearchParams() {
    const searchParams = new URLSearchParams(window.location.search);
    const params = {};
    searchParams.forEach((value, key) => {
        const numericValue = Number(value);
        params[key] = isNaN(numericValue) ? value : numericValue;  // Convert to number if applicable, otherwise keep as string
    });
    return params;
}

function noLocationHandle() {
    const variantsWrappers = document.querySelectorAll('.ss--variant-wrapper')
    const quantityWrapper = document.querySelector('.ss--quantity-input__wrapper')
    const addToCartButton = document.querySelector('.ss--cta-button.add-to-cart')
    const hidePurchaseUi = !window.inventories

    variantsWrappers.forEach(function (wrapper) {
        wrapper.style.display = hidePurchaseUi ? 'none' : ''
    })

    if (quantityWrapper) {
        quantityWrapper.style.display = hidePurchaseUi ? 'none' : ''
    }

    if (hidePurchaseUi && addToCartButton) {
        addToCartButton.style.display = 'none'
    }
}

// Setup to capture URL changes via history API
history.pushState = (f => function pushState() {
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('pushstate'));
    window.dispatchEvent(new Event('locationchange'));
    return ret;
})(history.pushState);

history.replaceState = (f => function replaceState() {
    var ret = f.apply(this, arguments);
    window.dispatchEvent(new Event('replacestate'));
    window.dispatchEvent(new Event('locationchange'));
    return ret;
})(history.replaceState);

window.addEventListener('popstate', () => {
    window.dispatchEvent(new Event('locationchange'));
});

window.addEventListener('locationchange', function () {
    const params = getCurrentSearchParams();
    if (params.variant) {
        localStorage.setItem('selected_variant_id', `${params.variant}`)
    }
});

// Log and return the search parameters immediately on page load
document.addEventListener('DOMContentLoaded', async (event) => {
    const isProductPage = document.querySelector('.ss--product-template__container')

    await initLocationFromUrlOrDefault();
    await maybeRequestZipFromLocation();

    if (window.location.pathname.includes('products') == false) {
        localStorage.setItem('selected_variant_id', 'none')
    } else {
        const params = getCurrentSearchParams();
        if (params.variant) {
            localStorage.setItem('selected_variant_id', `${params.variant}`)
        } else {
            const selectedShopifyVariant = getCurrentlySelectedShopifyVariant(
                document.querySelector('.ss--product-template__container')
            );
            if (selectedShopifyVariant) {
                localStorage.setItem('selected_variant_id', String(selectedShopifyVariant.id));
            }
        }
    }

    if (isProductPage && document.querySelector('.product-block--price') && !document.querySelector('.ss--inventory-control-message')) {
        await productDisplayPriceHandle();
    }
});

